import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

import * as Radio from '../radio-group'
import { FormControl } from './form'

const FormRadioGroupRoot = (props: ComponentProps<typeof Radio.Root>) => {
  return (
    <FormControl>
      <Radio.Root {...props} />
    </FormControl>
  )
}

type ItemProps = ComponentProps<typeof Radio.Item> & {
  weight?: ComponentProps<typeof Radio.Label>['weight']
}

const FormRadioGroupItem = ({ children, weight, ...props }: ItemProps) => {
  return (
    <Radio.Group>
      <FormControl
        render={({ ...formProps }) => (
          <Radio.Label
            {...formProps}
            weight={weight}
            className={cn('whitespace-break-spaces')}
          >
            <Radio.Item {...formProps} {...props} />
            {children}
          </Radio.Label>
        )}
      />
    </Radio.Group>
  )
}

export { FormRadioGroupRoot, FormRadioGroupItem }
